import { render, staticRenderFns } from "./UploadsInProgressPagePlaceholder.vue?vue&type=template&id=727008ac&scoped=true&"
import script from "./UploadsInProgressPagePlaceholder.vue?vue&type=script&lang=js&"
export * from "./UploadsInProgressPagePlaceholder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "727008ac",
  null
  
)

export default component.exports